// extracted by mini-css-extract-plugin
export default {"right":"right--kpLWs","infoIcon":"infoIcon--gLyRl"};